import { Navigate, Route, Routes } from "react-router-dom";
import { useLogin } from "../context/Login/LoginContext";
import AdminPanelDashboard from "../page/AdminPanel/AdminPanelDashboard";
import AdminPanelImportData from "../page/AdminPanel/AdminPanelImportData/AdminPanelImportData";
import AdminPanelJobList from "../page/AdminPanel/AdminPanelManageJobPostCard/AdminPanelJobList";
import AdminPanelManageJobPostCard from "../page/AdminPanel/AdminPanelManageJobPostCard/AdminPanelManageJobPostCard";
import AdminPanelManageUserCard from "../page/AdminPanel/AdminPanelManageUserCard";
import AdminPanelWrapper from "../page/AdminPanel/AdminPanelWrapper";
import Applications from "../page/Applications";
import JobsList from "../page/Jobs/JobsList";
import NotFound from "../page/NotFound";
import Portfolio from "../page/Profile/components/Portfolio/Portfolio";
import Profile from "../page/Profile/Profile";
import AcceptApplications from "../page/SelfCreateApplications";
import ServerSettings from "../page/ServerSettings";
import Setting from "../page/Setting";
import UsersList from "../page/Users/UsersList";
import DefaultLayoutWrapper from "./DefaultLayoutWrapper";
import Page from "./Page";

const AppRouter = () => {
    return (
        <DefaultLayoutWrapper>
            <Routes>
                <Route
                    index
                    path="/"
                    element={<Page render={<Navigate to="/jobs" replace />} />}
                />
                <Route path="/jobs" element={<Page render={<JobsList />} />} />
                <Route path="/users" element={<Page render={<UsersList />} />} />
                <Route path="/settings" element={<Page render={<Setting />} />} />

                <Route path="/applications" element={<LoginRequired render={<Applications />} />} />
                <Route path="/profile/:id" element={<Page render={<Profile />} />} />
                <Route path="/profile" element={<LoginRequired render={<Profile />} />} />
                <Route path="/portfolio/:id" element={<Page render={<Portfolio />} />} />

                <Route path="/admin" element={<AdminPanelComponent render={<AdminPanelDashboard />} />} />
                <Route path="/admin/users" element={<AdminPanelComponent render={<AdminPanelManageUserCard />} />} />
                <Route path="/admin/create-job" element={<AdminPanelComponent render={<AdminPanelManageJobPostCard />} />} />
                <Route path="/admin/update-job" element={<AdminPanelComponent render={<AdminPanelJobList />} />} />
                <Route path="/admin/accept-applications" element={<AdminPanelComponent render={<AcceptApplications />} />} />
                <Route path="/admin/server-settings" element={<AdminPanelComponent render={<ServerSettings />} />} />
                <Route path="/admin/import-data" element={<AdminPanelComponent render={<AdminPanelImportData />} />} />

                <Route path="*" element={<Page render={<NotFound />} />} />
            </Routes>
        </DefaultLayoutWrapper>
    )
}

const LoginRequired = ({ render }: { render: React.ReactNode }) => {
    const { isLoggedIn } = useLogin();
    if (!isLoggedIn) return <Page render={<NotFound />} />;
    return <Page render={render} />;
}

const AdminRequired = ({ render }: { render: React.ReactNode }) => {
    const { isLoggedIn, user } = useLogin();
    if (!isLoggedIn || user?.role !== "admin") return <Page render={<NotFound />} />;
    return <Page render={render} />;
}

const AdminPanelComponent = ({ render }: { render: React.ReactNode }) => {
    return (
        <AdminRequired render={
            <AdminPanelWrapper>
                {render}
            </AdminPanelWrapper>
        } />
    )
}

export default AppRouter;
